package uz.ferro.erp.feature.product.utils

import uz.ferro.erp.feature.product.model.Product
import uz.ferro.erp.feature.product.model.ProductProperty
import uz.ferro.erp.feature.product.model.ProductType
import uz.ferro.erp.util.toIntOrZero

fun Product.getValidityDays(): Int {
    val hours = properties.findIntData(PropertyKeys.PLAN_VALIDITY)
    if (hours >= 24) {
        return hours / 24
    }

    return 0
}

fun Product.getDataLimit(): String {
    val dataLimit = properties.findData(PropertyKeys.PLAN_DATA_LIMIT)
    val unit = properties.findData(PropertyKeys.PLAN_DATA_UNIT)
    if (dataLimit.isNotBlank()) {
        return "$dataLimit $unit".trim()
    }

    return ""
}

fun Product.getNetworkShort(): String {
    return properties.findData(PropertyKeys.NETWORKS_SHORT)
}

fun Product.hasData(): Boolean {
    return  properties.findData(PropertyKeys.HAS_DATA) == "1"
}

fun Product.hasCalls(): Boolean {
    return  properties.findData(PropertyKeys.HAS_CALLS) == "1"
}

fun Product.hasSMS(): Boolean {
    return  properties.findData(PropertyKeys.HAS_SMS) == "1"
}

fun Product.hotspotEnabled(): Boolean {
    return  properties.findData(PropertyKeys.HOTSPOT) == "1"
}

fun Product.speedLimit(): String {
    val speed = properties.findData(PropertyKeys.SPEED)
    return when (speed.lowercase()) {
        "limited" -> "Cheklangan"
        "unrestricted" -> "Cheklanmagan"
        else -> speed
    }
}

fun List<ProductProperty>?.findData(key: String): String {
    return this?.find { pp ->
        pp.property?.key == key
    }?.property?.value.orEmpty()
}

fun List<ProductProperty>?.findIntData(key: String): Int {
    return this?.find { pp ->
        pp.property?.key == key
    }?.property?.value.toIntOrZero()
}

fun ProductType?.displayName(): String {
    return when (this) {
        else -> ""
    }
}
